import * as constants from './provider-validation.constants';

const INITIAL_STATE = {
  data: null,
  isLoading: false,
  error: null,
};

export default function reducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case constants.action.PROVIDER_VALIDATION_LOADING:
      return {
        ...state,
        isLoading: true,
        error: null,
      };

    case constants.action.PROVIDER_VALIDATION_SUCCESS:
      return {
        ...state,
        isLoading: false,
        data: action.payload,
        error: null,
      };

    case constants.action.PROVIDER_VALIDATION_ERROR:
      return {
        ...state,
        isLoading: false,
        error: action.payload,
      };

    default:
      return state;
  }
}
